/* eslint-disable @typescript-eslint/no-explicit-any */
import {useNavigation, useRoute} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useState} from 'react';
import {View} from 'react-native';
import {connect} from 'react-redux';

import {defaultValues} from '../../../../data/constants/Assurance/AssuranceVoyage/resiliation';
import {ApiResponse} from '../../../../data/types/interface/api';
import {StackParams} from '../../../../data/types/navigation';
import {VoyageServices} from '../../../../services/applicatif/voyages';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import {BoxShadowed} from '../../../components/AssuranceVoyage';
import {HeaderScreen} from '../../../components/Header/HeaderScreen';
import Label from '../../../components/Label';
import {Loader} from '../../../components/Loader';
import ConfirmationModal from '../../../components/Modal/ConfirmationModal';
import {PageContainer} from '../../../components/PageContainer';
import {Form} from './Forms/FormWeb';
import {styles} from './styles';

type NavigationProps = StackNavigationProp<
  StackParams,
  'ResiliationAssuranceVoyage'
>;

const data = {
  ...defaultValues,
};

export const FResiliationAssuranceVoyageForm = () => {
  const {goBack} = useNavigation<NavigationProps>();
  const {resiliationContrat} = VoyageServices();

  const {params}: any = useRoute();

  const [dataDto] = useState(data);
  const [postSucces, setPostSuccess] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleCancel = () => {
    goBack();
  };

  const handleSubmit = (response: any) => {
    setIsLoading(true);
    resiliationContrat({
      policyId: params?.policyId.toString(),
      message: response.message,
    }).then((res: ApiResponse) => {
      setIsLoading(false);
      if (!res.isError) {
        setPostSuccess(true);
      } else {
        setErrorMessage(res.message);
        setShowErrorModal(true);
      }
    });
  };

  return (
    <View>
      <HeaderScreen
        title="Résiliation assurance voyage"
        type="retour"
        noBreadcrumb={false}
      />
      <PageContainer>
        {postSucces && (
          <ConfirmationModal
            title="Information"
            content="Votre demande à été prise en compte. Pour tout type de remboursement veuillez vous rendre auprès d'une agence ARO la plus proche."
            btn1="OK"
            handleBtn1={goBack}
          />
        )}
        {showErrorModal && (
          <ConfirmationModal
            title="Erreur"
            content={errorMessage}
            btn1="OK"
            handleBtn1={() => setShowErrorModal(false)}
          />
        )}
        {/** Loading */}
        {IsLoading && <Loader />}
        {/** Header content */}
        {!IsLoading && !postSucces && !showErrorModal ? (
          <BoxShadowed style={styles.header}>
            <Label
              title={params?.destination}
              type="mainTitle"
              style={{marginBottom: 10, marginTop: 0}}
              textStyle={{marginTop: 0}}
            />
            <Label title={params?.policyNumber} />
          </BoxShadowed>
        ) : null}
        {/** Form content */}
        {!postSucces && !IsLoading && !showErrorModal && (
          <Form
            data={dataDto}
            onCancelForm={handleCancel}
            onSubmitForm={handleSubmit}
          />
        )}
      </PageContainer>
    </View>
  );
};

export const ResiliationAssuranceVoyage: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FResiliationAssuranceVoyageForm);
